export { default } from './BlogPostsRecentes';
